import { Button, FormControlLabel, Paper, Switch, TablePagination } from "@mui/material";
import { color } from "../../../../theme/color";
import { ComponentState, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getClientAppointments, getClientDiagnosis, saveClientDiagnosis } from "../../../../redux/actions";
import { AppointmentModel, DiagnosisModel } from "../../../../dataModel/clientModels";
import moment from "moment";
import SkeletonTypography from "../../../../components/SkeletonTypography";
export interface AppointmentsProps {
  isHomeScreen?: Boolean
}

export const Appointments = (props: AppointmentsProps) => {
  const dispatch = useDispatch()
  // const [showPastDx, setShowPastDx] = useState(false)
  const [loading, setLoading] = useState(false)
  const [pageSize, setPageSize] = useState(10)
  const [pageNumber, setPageNumber] = useState(0)

  const [isListFetched, setListFetched] = useState(false)
  const state: ComponentState = useSelector(states => {
    return states;
  });
  const { appointmentList } = state['AppointmentReducer'];

  useEffect(() => {
    if (appointmentList) {
      setLoading(false)
    }
  }, [appointmentList])

  useEffect(() => {
    if (!isListFetched) {
      setLoading(true)
      dispatch(getClientAppointments())
      setListFetched(true)
    }
  }, [isListFetched])

  function handleChangePage(event: any, newpage: any) {
    setPageNumber(newpage)
  }

  function handleChangeRowsPerPage(event: any) {

    setPageSize(parseInt(event.target.value, 10))
    setPageNumber(0)
  }

  useEffect(() => {

  }, [pageNumber, pageSize])

  return (
    <>
    <div className="infoWrapper">
      <div className="tab-pane treatment-plan-head" role="tabpanel">
        <h1 style={{  marginBottom: "30px", fontSize: "22px", fontWeight: "600" }} >
          <div color={color.palette.black}>
          </div>
          Upcoming Appointments
        </h1>

        {loading ?
          <SkeletonTypography />
          : (appointmentList.length < 1) ?
            <div>No upcoming appointments in your calender.</div>
            : <Paper>
              {<table className="table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Time</th>

                    {/* <th>Title</th> */}
                    {/* <th>Join Telehealth</th> */}
                  </tr>
                </thead>
                <tbody style={{ padding: "auto 10px auto 10px" }}>
                  {
                    appointmentList.slice((pageNumber) * pageSize, (pageNumber) * pageSize + pageSize)?.map((item: AppointmentModel) => {
                      const isCancelledEvent = item.eventStatusName.toLowerCase().includes('cancel')
                      const jointUr = item.joinUrl ? item.joinUrl : '';
                      return (
                        <tr >
                          <td className={isCancelledEvent ? "line-thru fw-500" : ""}>{moment(item.dateStart).format('MM/DD/YY')} - {moment(item.dateEnd).format('MM/DD/YY')}</td>

                          {
                            (!isCancelledEvent && item.isTelehealth && jointUr && jointUr != null) ?
                              <td>  <li className="col-4 px-0 fw-500">
                                {moment(item.dateStart).format('hh:mm A') + ' - ' + moment(item.dateEnd).format('hh:mm A') + '  '}
                                <a href={jointUr} className="join-btn">Join</a>

                              </li></td>
                              : <td>  <span className={isCancelledEvent ? "line-thru fw-500" : "fw-500"}>{moment(item.dateStart).format('hh:mm A') + ' - ' + moment(item.dateEnd).format('hh:mm A')} </span></td>

                          }

                          {/* <td>{item.title}</td> */}

                        </tr>
                      )
                    })
                  }
                </tbody>
              </table>
              }

              <TablePagination
                rowsPerPageOptions={[10, 25, 50, 100, 500]}
                component="div"
                count={appointmentList?.length ?? 0}
                rowsPerPage={pageSize}
                page={pageNumber}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>}
      </div>
      </div>

    </>)
}

